import _Promise from 'babel-runtime/core-js/promise';
import { getWindowSize } from './device';
import Observer from './observer';

export var stopPropagation = function stopPropagation(e) {
  e.stopPropagation();
};

/*
  please bind this function to your component with a callback param
  this.onResize = utils.DOM.onResizeEnd.bind(this, this.calculateHeight)
*/
export var onResizeEnd = function onResizeEnd() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  var callback = arguments[1];

  clearTimeout(this.resizeTimeout);
  this.resizeTimeout = setTimeout(callback, duration);
};

export var preventDefault = function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
};

export var returnFalse = function returnFalse(e) {
  e.returnValue = false;
};

export var disableScroll = function disableScroll(e) {
  /* older ffx */
  if (window.addEventListener) {
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  }
  /* standard */
  window.onwheel = preventDefault;
  /* older browsers, ie */
  window.onmousewheel = document.onmousewheel = preventDefault;
  /* mobile */
  window.addEventListener('touchmove', returnFalse, { passive: true });
};

export var enableScroll = function enableScroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  }
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.removeEventListener('touchmove', returnFalse, { passive: true });
};

export var scrollWhenExistsToElementWithId = function scrollWhenExistsToElementWithId(id, scrollContainer) {
  /* do not console.log scrollContainer : freezes the app (large document element) */
  if (typeof scrollContainer === 'string') {
    scrollContainer = document.getElementById(scrollContainer);
  }
  if (!scrollContainer) {
    console.debug('scrollContainer undefined');
    return _Promise.resolve();
  }
  return new _Promise(function (resolve, reject) {
    if (!id) {
      console.debug('scrollToElementById - id undefined');
      resolve();
      return;
    }
    var observer = new Observer();
    observer.when('[id=\'' + id + '\']', function () {
      return setTimeout(function () {
        var element = document.getElementById(id);
        if (!element) {
          console.debug('scrollToElementById - DOM element with id ' + id + ' not found');
          resolve();
          return;
        }

        /* scroll to element (center of container) */
        var scrollTo = element.getBoundingClientRect().top + scrollContainer.scrollTop - getWindowSize().height / 2;
        if (scrollTo < 0) {
          scrollTo = 0;
        }

        scrollContainer = scrollContainer || window;
        scrollContainer.scrollTo && scrollContainer.scrollTo({
          top: scrollTo,
          behavior: 'smooth'
        });

        resolve();
        observer.disconnect();
      }, 200);
    });
  });
};
//# sourceMappingURL=DOM.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/DOM.js
// module id = 754
// module chunks = 0